import styled from "styled-components";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";

export const TermOfService: React.FC = () => {
  return (
    <Container>
      <TitleWrapper>利用規約</TitleWrapper>

      <Caption>
        ジョイフル（以下「当社」といいます）は、当社が運営するWebサイト「Joyfull
        ネット注文」（以下「当サイト」）といいます）を利用して当社の店舗（加盟店を含みます。）で提供するメニューを予約し、当該店舗にて商品をお受け取りいただくサービス（以下「本サービス」といいます）の利用について以下のとおり定めます（以下「本規約」といいます）。本サービスをご利用いただくためには、本規約にご同意いただいたうえで利用者登録を行っていただく必要がございます。
      </Caption>

      <Article>
        <ArticleHeader>第1条（本規約の適用範囲および変更）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  本規約は本サービスの提供およびその利用に関し、当社および利用者（第3条で定義します）に適用されるものとします。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  当社は、利用者への事前の通知をすることなく、本規約を変更できるものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <FooterArea>
        <p>2015年7月16日制定</p>
        <p>2016年1月1日最終改定</p>
      </FooterArea>

      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 16px 68px;
  color: #333333;
`;

const TitleWrapper = styled.p`
  font-size: 20px;
  font-weight: 600;
  padding: 43px 0 5px 0;
  display: flex;
  justify-content: center;
  line-height: 1;
  font-family: "Hiragino Sans";
`;

const Caption = styled.p`
  font-weight: 200;
  margin: 30px 0;
  text-align: left;
  font-size: 14px;
  line-height: 21px;
  font-family: "Hiragino Sans";
`;

const Article = styled.div`
  margin-top: 30px;
`;

const ArticleHeader = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 26px;
  border-bottom: 1px solid #000;
  margin: 8px 0 10px 0;
  font-family: "Hiragino Sans";
`;

const ArticleTableContent = styled.div`
  table {
    line-height: 21px;
    font-size: 14px;
    font-weight: 200;
    border-collapse: separate;
    border-spacing: 0 8px;
    font-family: "Hiragino Sans";

    .label {
      vertical-align: text-top;
      padding-right: 5px;
      font-family: "Hiragino Sans";
    }
    .info {
      font-family: "Hiragino Sans";
    }
  }
`;

const FooterArea = styled.div`
  text-align: right;
  margin-top: 56px;
  margin-bottom: 38px;
  font-size: 14px;
  font-weight: 200;
  p {
    font-family: "Hiragino Sans";
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 60px;
  button {
    height: auto;
    line-height: 1;
    font-weight: 500;
    font-family: "Hiragino Sans";
  }
`;
